import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import trophyIcon from "../../assets/images/trophy.png";
import { useMutation } from "@apollo/client";
import { BUY_COUPON } from "queries/mutations";
import backArrow from '../../assets/images/left_arrow.png';
import info from "../../assets/images/info.svg";
import closeIcon from "../../assets/images/close_icon.png";

const ERROR_MESSAGES = {
  campaign_not_found: "Kampagne nicht gefunden.",
  invalid_promotion_code: "Ungültiger Promotion-Code.",
  already_purchased: "Du hast diese Aktion bereits eingelöst.",
  not_enough_points: "Du hast nicht genug Punkte.",
  no_available_coupon_codes: "Keine Gutscheincodes mehr verfügbar.",
  unexpected_error: "Ein unerwarteter Fehler ist aufgetreten.",
};

const CouponCampaignDetailContent = ({ campaign }) => {
  const history = useHistory();
  const [promotionCode, setPromotionCode] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const withoutTime = { year: "2-digit", month: "2-digit", day: "2-digit" };

  const isInstantType = campaign.campaignType === "instant";

  const [showRules, setShowRules] = useState(false);
  useEffect(() => {
    if (!showRules) return;
    const onKey = (e) => e.key === "Escape" && setShowRules(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showRules]);

  useEffect(() => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;

    wrapper.addEventListener(
      "touchmove",
      function (event) {
        event.stopPropagation();
      },
      false
    );
  });
  
  const handleBack = () => {
    history.goBack() 
  };

  const [buyCouponMutation] = useMutation(BUY_COUPON, {
    onCompleted({ buyCoupon: { isSuccess, error } }) {
      if (isSuccess) {
        history.push({
          pathname: `/my-coupon/${campaign?.id}`,
          state: { campaign },
        });
      } else {
        setErrorMessage(ERROR_MESSAGES[error] ?? ERROR_MESSAGES.unexpected_error);
      }
    },
    onError: () => {
      setErrorMessage(ERROR_MESSAGES.unexpected_error);
    },
  });

  const buyCoupon = () => {
    setErrorMessage("");
    buyCouponMutation({
      variables: {
        campaignId: campaign.id,
        ...(isInstantType && { promotionCode }),
      },
    });
  };

  return (
    <div className="campaign-details-content scrollable">
      <img 
        src={backArrow} 
        alt="back" 
        className="points-header-arrow" 
        onClick={handleBack} 
      />
      <img
        src={campaign.coverImageUrl}
        className="campaign-details-image"
      />
      <div>
        <div className="campaign-details-info">
          <div className="campaign-details">
            <div className="campaign-details-supplier">{campaign.supplier}</div>
            <div className="campaign-details-expires">
              Gültig Bis:{" "}
              {new Date(
                campaign.expiresAt.split(" ")[0].replace(/-/g, "/")
              ).toLocaleDateString("de", withoutTime)}
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <div className="campaign-details-title" style={{ lineHeight: 1 }}>
              {campaign.title}
            </div>
            {campaign.participantRules && <img
              src={info}
              alt="Teilnahmebedingungen"
              role="button"
              tabIndex={0}
              onClick={() => setShowRules(true)}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setShowRules(true)}
              style={{ cursor: "pointer", width: 18, height: 18, flexShrink: 0 }}
            />}
          </div>
        </div>

        {isInstantType ? (
          <div className="points-container">
            <input
              type="text"
              className="coupon-code-input"
              placeholder="Code eingeben"
              value={promotionCode}
              onChange={(e) => setPromotionCode(e.target.value)}
            />
          </div>
        ) : (
          <div className="points-container">
            <img
              src={trophyIcon}
              alt="Trophy Icon"
              className="points-icon"
            />
            <div className="points-number">{campaign.points}</div>
            <div className="points-text">Punkte</div>
          </div>
        )}

        {errorMessage && (
          <div className="coupon-error-message">{errorMessage}</div>
        )}

        <div
          className="campaign-description"
          dangerouslySetInnerHTML={{ __html: campaign.description }}
        />
      </div>
      <button
        className="trainer-message-button"
        disabled={isInstantType && !promotionCode.trim()}
        onClick={buyCoupon}
      >
        Coupon einlösen
      </button>

      {showRules && (
        <div
          className="modal-overlay"
          onClick={() => setShowRules(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          aria-modal="true"
          role="dialog"
        >
          <div
            className="modal-card"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxHeight: "80vh",
              overflowY: "auto",
              background: "#fff",
              borderRadius: 16,
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              padding: 20,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
              <div style={{ fontWeight: 700, fontSize: 18 }}>Teilnahmebedingungen</div>
              <button
                onClick={() => setShowRules(false)}
                aria-label="Schließen"
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: 20,
                  cursor: "pointer",
                  lineHeight: 1,
                  padding: 0,
                }}
              >
                <img src={closeIcon} alt="Close" style={{ width: '20px'}}/>
              </button>
            </div>

            <div style={{ marginTop: 12, color: "#4d4d4d", whiteSpace: "pre-wrap" }}>
              {campaign.participantRules || "Keine Teilnahmebedingungen verfügbar."}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CouponCampaignDetailContent;